/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import type {
	Command,
	FloatingToolbarButton as FloatingToolbarButtonDescriptor,
} from '@atlaskit/editor-common/types';
import { ConversationAssistantButtonNav4 } from '@atlassian/conversation-assistant-ui-components/ui/ConversationAssistantButton';

/** Props for the Ask Rovo toolbar button. */
export type AskRovoToolbarButtonProps = {
	button: FloatingToolbarButtonDescriptor<Command>;
	onClick: () => void;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const buttonWrapperStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles -- Remove TopNavButton ::after border
	'& button': { '&::after': { display: 'none' } },
});

/**
 * Renders the Ask Rovo button for the native embed floating toolbar.
 */
export function AskRovoToolbarButton({
	button,
	onClick,
}: AskRovoToolbarButtonProps): React.JSX.Element {
	const tooltipContent =
		typeof button.tooltipContent !== 'function' ? button.tooltipContent : undefined;
	return (
		<div css={buttonWrapperStyles}>
			<ConversationAssistantButtonNav4
				isActive={false}
				label={button.title}
				onClick={onClick}
				productKey="confluence"
				siteId="stub-site-id"
				tooltipContent={tooltipContent}
			/>
		</div>
	);
}
